import { render, staticRenderFns } from "./PublicBookingCard.vue?vue&type=template&id=50a839fe&scoped=true"
import script from "./PublicBookingCard.vue?vue&type=script&lang=js"
export * from "./PublicBookingCard.vue?vue&type=script&lang=js"
import style0 from "./PublicBookingCard.vue?vue&type=style&index=0&id=50a839fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a839fe",
  null
  
)

export default component.exports